<div provide-parent-form *ngIf="playout">

	<h3>{{ 'AUTO_OPTIONS' | translate }}</h3>

	<bb-form-element [form]="form" [label]="'AUTOPLAY' | translate" [helpMessage]="'HELP.AUTOPLAY' | translate">
		<bb-check name="playout-autoPlay" [(ngModel)]="playout.autoPlay" [trueValue]="'true'" [falseValue]="'false'">
		</bb-check>
	</bb-form-element>

	<bb-form-element [disabled]="playout.autoPlay !== 'true'" [form]="form"
		[label]="'PLAYOUT_AUTOPLAY_ONLY_WITH_PREROLL_AD' | translate"
		[helpMessage]="'PLAYOUT_AUTOPLAY_ONLY_WITH_PREROLL_AD' | translate" class="tab-indent">
		<bb-check name="playout-autoPlayOnlyWithPrerollAd" [(ngModel)]="playout.autoPlayOnlyWithPrerollAd"
			[trueValue]="'true'" [falseValue]="'false'">
		</bb-check>
	</bb-form-element>

	<bb-form-element *ngIf="playout.autoPlay === 'true' && playout.autoMute === 'false'" [form]="form"
		[label]="'PLAYOUT_AVOID_MUTED_AUTOPLAY' | translate"
		[helpMessage]="'HELP.PLAYOUT_AVOID_MUTED_AUTOPLAY' | translate" class="tab-indent">
		<bb-check name="playout-avoidMutedAutoPlay" [(ngModel)]="playout.avoidMutedAutoPlay" [trueValue]="'true'"
			[falseValue]="'false'">
		</bb-check>
	</bb-form-element>

	<bb-form-element [form]="form" [label]="'FORCE_CAN_AUTOPLAY' | translate" [hasPublicationField]="'forceCanAutoPlay'"
		[helpMessage]="'HELP.AUTOPLAY' | translate">
		<bb-check name="playout-forceCanAutoPlay" [(ngModel)]="playout.forceCanAutoPlay" [trueValue]="'true'"
			[falseValue]="'false'">
		</bb-check>
	</bb-form-element>

	<bb-form-element [form]="form" [label]="'AUTOMUTE' | translate" [helpMessage]="'HELP.AUTOMUTE' | translate">
		<bb-check name="playout-autoMute" [(ngModel)]="playout.autoMute" [trueValue]="'true'" [falseValue]="'false'">
		</bb-check>
	</bb-form-element>

	<bb-form-element [form]="form" [label]="'AUTOLOOP' | translate">
		<bb-check name="playout-autoLoop" [(ngModel)]="playout.autoLoop" [trueValue]="'true'" [falseValue]="'false'">
		</bb-check>
	</bb-form-element>

	<h3>{{ 'IN_AND_OUTVIEW' | translate }} <bb-info [contents]="'HELP.IN_AND_OUTVIEW' | translate"
			[link]="'https://support.bluebillywig.com/video-player/customising-player/#6-2-in-out-view'">
		</bb-info>
	</h3>

	<bb-form-element [form]="form" [label]="'STICKY_OPTIONS' | translate"
		[helpMessage]="'HELP.STICKY_OPTIONS' | translate">
		<bb-select [(ngModel)]="playout.stickyMode" [preset]="'stickyMode'" name="playout-stickyMode"></bb-select>
	</bb-form-element>

	<ng-container *ngIf="playout.stickyMode === 'stickToElement'">
		<bb-form-element [form]="form" [label]="'DOM_FLOAT_ELEMENT' | translate"
		[helpMessage]="'HELP.FLOAT_TO_ELEMENT' | translate">
		<input type="text" name="playout-domFloatElement" [(ngModel)]="playout.domFloatElement"
			[placeholder]="'ENTER_DOM_ELEMENT_TO_FLOAT_TO' | translate" />
		</bb-form-element>

		<bb-form-element [form]="form" [label]="'DOM_ELEMENT_ALIGNMENT' | translate">
			<bb-select [(ngModel)]="playout.domElementAlignment" name="playout-domElementAlignment">
				<option value="stickTopLeft">{{ 'FLOAT_TO_TOP_LEFT' | translate }}</option>
				<option value="stickBottomLeft">{{ 'FLOAT_TO_BOTTOM_LEFT' | translate }}</option>
				<option value="stickTopRight">{{ 'FLOAT_TO_TOP_RIGHT' | translate }}</option>
				<option value="stickBottomRight">{{ 'FLOAT_TO_BOTTOM_RIGHT' | translate }}</option>
			</bb-select>
		</bb-form-element>
	</ng-container>

	<ng-container
		*ngIf="playout.stickyMode === 'stickBottomRight' || playout.stickyMode === 'stickBottomLeft' || playout.stickyMode === 'stickTopRight' || 
				playout.stickyMode === 'stickTopLeft' || playout.stickyMode === 'stickDownBottomRight' || playout.stickyMode === 'stickDownBottomLeft' ||
				playout.stickyMode === 'stickDownTopCenter' || playout.stickyMode === 'stickToElement'">
		<bb-form-element [form]="form" [label]="'ALWAYS_FLOAT' | translate"
			[helpMessage]="'HELP.ALWAYS_FLOAT' | translate">
			<bb-check name="playout-alwaysFloat" [(ngModel)]="playout.alwaysFloat" [trueValue]="'true'"
				[falseValue]="'false'">
			</bb-check>
		</bb-form-element>

		<bb-form-element *ngIf="playout.alwaysFloat === 'true'" [form]="form" [label]="'SHOW_CLOSE_BUTTON' | translate">
			<bb-check name="playout-showFloatingCloseButton" [(ngModel)]="playout.showFloatingCloseButton" [trueValue]="'true'"
				[falseValue]="'false'">
			</bb-check>
		</bb-form-element>

		<bb-form-element [form]="form" [label]="'DISABLE_FLOAT_ANIMATION' | translate"
		[helpMessage]="'HELP.DISABLE_FLOAT_ANIMATION' | translate">
		<bb-check name="playout-disableFloatAnimation" [(ngModel)]="playout.disableFloatAnimation" [trueValue]="'true'"
			[falseValue]="'false'">
		</bb-check>
		</bb-form-element>

		<bb-form-element [form]="form" [label]="'WIDTH_WHEN_FLOATING' | translate"
			[helpMessage]="'HELP.WIDTH_WHEN_FLOATING' | translate"
			[helpMessageLink]="'https://support.bluebillywig.com/video-player/customising-player/#6-2-in-out-view'">
			<input type="text" name="playout-floatingWidth" [(ngModel)]="playout.floatingWidth"
				[placeholder]="'ENTER_NUMBER_OR_JAVASCRIPT_RETURNING_NUMBER_OR_BLANK' | translate" />
		</bb-form-element>

		<bb-form-element [label]="'MINIMUM_FLOAT_WIDTH' | translate"
			[helpMessage]="'HELP.MINIMUM_FLOAT_WIDTH' | translate">
			<bb-dimension name="playout-minimumFloatWidth" [(ngModel)]="playout.minimumFloatWidth"
				[units]="minWidthUnits" [placeholder]="'LEAVE_BLANK_TO_DISABLE' | translate"></bb-dimension>
		</bb-form-element>

		<bb-form-element [form]="form" [label]="'DISTANCE_FROM_TOP' | translate" [helpMessage]="'HELP.DISTANCE_FROM_TOP' | translate"
				[helpMessageLink]="'https://support.bluebillywig.com/video-player/customising-player/#6-2-in-out-view'">
			<textarea [(ngModel)]="playout.distanceFromTop" name="playout-distanceFromTop"
				placeholder="{{ 'ENTER_NUMBER_OR_JAVASCRIPT_RETURNING_NUMBER_JS' | translate }}; {{ 'LEAVE_BLANK_TO_DISABLE' | translate }}" rows="1"></textarea>
		</bb-form-element>

		<bb-form-element [form]="form" [label]="'DISTANCE_FROM_BOTTOM' | translate" [helpMessage]="'HELP.DISTANCE_FROM_BOTTOM' | translate"
				[helpMessageLink]="'https://support.bluebillywig.com/video-player/customising-player/#6-2-in-out-view'">
			<textarea [(ngModel)]="playout.distanceFromBottom" name="playout-distanceFromBottom"
				placeholder="{{ 'ENTER_NUMBER_OR_JAVASCRIPT_RETURNING_NUMBER_JS' | translate }}; {{ 'LEAVE_BLANK_TO_DISABLE' | translate }}" rows="1"></textarea>
		</bb-form-element>
	</ng-container>

	<bb-form-element [form]="form" [label]="'START_COLLAPSED' | translate" [hasPublicationField]="'startCollapsed'"
		[helpMessage]="'HELP.START_COLLAPSED' | translate"
		>
		<bb-check name="playout-startCollapsed" [(ngModel)]="playout.startCollapsed" [trueValue]="'true'"
			[falseValue]="'false'">
		</bb-check>
	</bb-form-element>

	<bb-form-element [form]="form" [label]="'COLLAPSE_ON_END' | translate"
		[helpMessage]="'HELP.COLLAPSE_ON_END' | translate"
		>
		<bb-check name="playout-hidePlayerOnEnd" [(ngModel)]="playout.hidePlayerOnEnd" [trueValue]="'true'"
			[falseValue]="'false'">
		</bb-check>
	</bb-form-element>

	<bb-form-element [form]="form" [label]="'IN_VIEW_ACTION' | translate" [helpMessage]="'HELP.INVIEW_IFRAME' | translate">
		<bb-select [(ngModel)]="playout.interactivity_inView" name="playout-interactivity_inView" [preset]="'interactivityInview'"></bb-select>
	</bb-form-element>

	<bb-form-element
		[disabled]="playout.interactivity_inView !== 'play' && playout.interactivity_inView !== 'play and unmute'"
		[form]="form" [label]="'PLAYOUT_AUTOPLAY_ONLY_WITH_PREROLL_AD' | translate"
		[helpMessage]="'HELP.PLAYOUT_AUTOPLAY_ONLY_WITH_PREROLL_AD' | translate" class="tab-indent">
		<bb-check name="playout-autoPlayOnlyWithPrerollAd"
			[(ngModel)]="playout.autoPlayOnlyWithPrerollAd" [trueValue]="'true'" [falseValue]="'false'">
		</bb-check>
	</bb-form-element>

	<bb-form-element [disabled]="playout.stickyMode === 'stickBottomRight' || playout.stickyMode === 'stickBottomLeft' || playout.stickyMode === 'stickTopRight' || 
	playout.stickyMode === 'stickTopLeft' || playout.stickyMode === 'stickBoth'" [form]="form"
		[label]="'OUT_VIEW_ACTION' | translate" [helpMessage]="'HELP.STICKY_OUTVIEW' | translate">
		<bb-select [(ngModel)]="playout.interactivity_outView" name="playout-interactivity_outView" [preset]="'interactivityOutview'"></bb-select>
	</bb-form-element>

	<bb-form-element [form]="form" [label]="'FORCE_INVIEW_ACTIONS' | translate"
		[helpMessage]="'HELP.FORCE_INVIEW_ACTIONS' | translate">
		<bb-check name="playout-forceInview" [(ngModel)]="playout.forceInview" [trueValue]="'true'"
			[falseValue]="'false'">
		</bb-check>
	</bb-form-element>

	<bb-form-element
		*ngIf="playout.interactivity_inView !== 'none' || (playout.stickyMode && playout.stickyMode !== '')"
		[form]="form" [label]="'IN_VIEW_MARGIN' | translate" [helpMessage]="'HELP.IN_VIEW_MARGIN' | translate"
		[helpMessageLink]="'https://support.bluebillywig.com/video-player/customising-player/#6-2-in-out-view'">
		<input type="text" name="playout-inviewMargin" [(ngModel)]="playout.inviewMargin" />
	</bb-form-element>

	<h3>{{ 'KEYBOARD' | translate }}</h3>

	<bb-form-element [form]="form" [label]="'DISABLE_KEYBOARD_CONTROLS' | translate"
		[helpMessage]="'HELP.PLAYER_KEYBOARD_CONTROLS' | translate">
		<bb-check name="playout-disableKeyboardControls" [(ngModel)]="playout.disableKeyboardControls"
			[trueValue]="'true'" [falseValue]="'false'">
		</bb-check>
	</bb-form-element>

	<h3>{{ 'MOUSE' | translate }}</h3>

	<bb-form-element [form]="form" [label]="'MOUSE_IN_ACTION' | translate">
		<bb-select [(ngModel)]="playout.interactivity_mouseIn" name="playout-interactivity_mouseIn" [preset]="'interactivityInview'"></bb-select>
	</bb-form-element>

	<bb-form-element [form]="form" [label]="'MOUSE_OUT_ACTION' | translate">
		<bb-select [(ngModel)]="playout.interactivity_mouseOut" name="playout-interactivity_mouseOut" [preset]="'interactivityOutview'"></bb-select>
	</bb-form-element>

	<bb-form-element [form]="form" [label]="'ON_CLICK_ACTION' | translate">
		<bb-select [(ngModel)]="playout.interactivity_onClick" name="playout-interactivity_onClick">
			<option value="none">{{ 'NONE' | translate }}</option>
			<option value="play or pause">{{ 'PLAY_OR_PAUSE' | translate }}</option>
			<option [hasPublicationField]="'player_on_click'" value="open link in current window">{{ 'OPEN_LINK_IN_CURRENT_WINDOW' | translate }}</option>
			<option [hasPublicationField]="'player_on_click'" value="open link in new window">{{ 'OPEN_LINK_IN_NEW_WINDOW' | translate }}</option>
		</bb-select>
	</bb-form-element>

	<ng-container *ngIf="playout.interactivity_onClick === 'open link in current window' || playout.interactivity_onClick === 'open link in new window'">
		<bb-form-element [form]="form" [label]="'ON_CLICK_URL' | translate" [hasPublicationField]="'player_on_click'">
			<input type="text" name="playout-clickUrl" [(ngModel)]="playout.clickUrl" />
		</bb-form-element>
	</ng-container>

	<h3 [hasPublicationField]="'textAbovePlayer' || 'textCommercialSkip'">{{ 'DISPLAY_SETTINGS' | translate }}</h3>

	<bb-form-element [hasPublicationField]="'textAbovePlayer'" [form]="form"
		[label]="'PLAYOUT_TEXT_ABOVE_PLAYER' | translate">
		<input type="text" name="playout-textAbovePlayer" [(ngModel)]="playout.textAbovePlayer"
			[placeholder]="'LEAVE_BLANK_TO_DISABLE' | translate" />
	</bb-form-element>

	<bb-form-element [hasPublicationField]="'textCommercialSkip'" [form]="form"
		[label]="'PLAYOUT_TEXT_CLOSE_PLAYER' | translate">
		<input type="text" name="playout-textCommercialSkip" [(ngModel)]="playout.textCommercialSkip"
			[placeholder]="'PLAYOUT_TEXT_CLOSE_PLAYER' | translate" />
	</bb-form-element>

	<h3>{{ 'PLACEMENT_OPTIONS' | translate }}</h3>

	<bb-form-element [form]="form" [label]="'PLAYOUT_PLACEMENT_OPTION' | translate"
		[helpMessage]="'HELP.PLACEMENT_OPTION' | translate"
		[helpMessageLink]="'https://support.bluebillywig.com/video-player/customising-player/#6-5-placement-options'">
		<bb-select [(ngModel)]="playout.placementOption" name="playout-placementOption">
			<option value="default">{{ 'AT_SCRIPT_POSITION_(DEFAULT)' | translate }}</option>
			<option value="afterSelector">{{ 'AFTER_MATCHING_ELEMENT' | translate }}</option>
			<option value="appendTo">{{ 'APPEND_TO_MATCHING_ELEMENT' | translate }}</option>
			<option value="halfwaySelectors">{{ 'HALFWAY_MATCHING_ELEMENTS' | translate }}</option>
			<option value="fold">{{ 'AFTER_MATCHING_AFTER_FOLD' | translate }}</option>
			<option value="foldOrLast">{{ 'AFTER_MATCHING_AFTER_FOLD_OR_LAST' | translate }}</option>
		</bb-select>
	</bb-form-element>

	<bb-form-element *ngIf="playout.placementOption !== 'default'" [form]="form"
		[label]="'PLAYOUT_PLACEMENT_DOM_SELECTOR' | translate"
		[helpMessage]="'HELP.PLACEMENT_DOM_SELECTOR' | translate"
		[helpMessageLink]="'https://support.bluebillywig.com/video-player/customising-player/#6-5-placement-options'">
		<input type="text" name="playout-placementDOMSelector" [(ngModel)]="playout.placementDOMSelector" />
	</bb-form-element>

	<bb-form-element [form]="form" [label]="'WAIT_FOR_CMP' | translate"
		[helpMessage]="'HELP.PLACEMENT_WAIT_FOR_CMP' | translate"
		[helpMessageLink]="'https://support.bluebillywig.com/video-player/customising-player/#6-5-placement-options'">
		<bb-check name="playout-waitForCmp" [(ngModel)]="playout.waitForCmp" [trueValue]="'true'"
			[falseValue]="'false'">
		</bb-check>
	</bb-form-element>

	<bb-form-element *ngIf="playout?.waitForCmp === 'true'" [form]="form"
		[label]="'CMP_TIMEOUT' | translate"
		[helpMessage]="'HELP.CMP_TIMEOUT' | translate"
		[helpMessageLink]="'https://support.bluebillywig.com/video-player/customising-player/#6-5-placement-options'">
		<input type="number" name="playout-cmpTimeout" [(ngModel)]="playout.cmpTimeout"
			[placeholder]="'10000' | translate" min="0" [formControl]="cmpTimeoutFormControl"/>
	</bb-form-element>

	<bb-form-element [hasPublicationField]="'iframeBreakout'" [form]="form"
		[label]="'PLAYOUT_IFRAME_BREAKOUT' | translate" [helpMessage]="'HELP.PLAYOUT_IFRAME_BREAKOUT' | translate"
		[helpMessageLink]="'https://support.bluebillywig.com/video-player/customising-player/#6-5-placement-options'">
		<bb-check name="playout-iframeBreakout" [(ngModel)]="playout.iframeBreakout" [trueValue]="'true'"
			[falseValue]="'false'">
		</bb-check>
	</bb-form-element>

	<bb-form-element [hasPublicationField]="'clearBothOption'" [form]="form"
		[label]="'PLAYOUT_CLEAR_BOTH_OPTION' | translate" [helpMessage]="'HELP.CLEAR_BOTH_OPTION' | translate"
		[helpMessageLink]="'https://support.bluebillywig.com/video-player/customising-player/#6-5-placement-options'">
		<bb-select [(ngModel)]="playout.clearBothOption" name="playout-clearBothOption">
			<option value="never">{{ 'NEVER' | translate }}</option>
			<option value="whilePlaying">{{ 'ADD_CLEAR_BOTH_WHILE_PLAYING' | translate }}</option>
			<option value="always">{{ 'ADD_CLEAR_BOTH_ALWAYS' | translate }}</option>
		</bb-select>
	</bb-form-element>

	<bb-form-element [form]="form" [label]="'SHOW_ONLY_WHEN_PREROLL_AVAILABLE' | translate"
		[helpMessage]="'HELP.SHOW_ONLY_WHEN_PREROLL_AVAILABLE' | translate"
		[hasPublicationField]="'showExtraPlayoutFields'">
		<bb-check name="showOnlyWhenPrerollAvailable" [(ngModel)]="playout.showOnlyWhenPrerollAvailable" [trueValue]="'true'"
			[falseValue]="'false'">
		</bb-check>
	</bb-form-element>

	<div [hasPublicationField]="'nsiNoAutoPlay OR nsiNoPlayer'">
		<h3>{{ 'NO_SOUND_INFLUENCE_OPTIONS' | translate }} <bb-info
				[contents]="'HELP.NO_SOUND_INFLUENCE_OPTIONS' | translate">
			</bb-info>
		</h3>

		<bb-form-element [hasPublicationField]="'nsiNoAutoPlay'" [form]="form"
			[label]="'NO_SOUND_INFLUENCE_NO_AUTOPLAY' | translate"
			[helpMessage]="'HELP.NO_SOUND_INFLUENCE_NO_AUTOPLAY' | translate">
			<bb-check name="playout-nsiNoAutoPlay" [(ngModel)]="playout.nsiNoAutoPlay" [trueValue]="'true'"
				[falseValue]="'false'">
			</bb-check>
		</bb-form-element>

		<bb-form-element [hasPublicationField]="'nsiNoPlayer'" [form]="form"
			[label]="'NO_SOUND_INFLUENCE_NO_PLAYER' | translate"
			[helpMessage]="'HELP.NO_SOUND_INFLUENCE_NO_PLAYER' | translate">
			<bb-check name="playout-nsiNoPlayer" [(ngModel)]="playout.nsiNoPlayer" [trueValue]="'true'"
				[falseValue]="'false'">
			</bb-check>
		</bb-form-element>
	</div>

	<div [hasPublicationField]="'eventHanders'">
		<h3>{{ 'EVENT_HANDLERS' | translate }}</h3>

		<bb-event-handlers name="playout-eventHandlers" [(ngModel)]="playout.eventHandlers"></bb-event-handlers>
	</div>

	<h3>{{ 'MISCELLANEOUS' | translate }}</h3>

	<bb-form-element [label]="'TEXT_ALTERNATIVE' | translate" [helpMessage]="'HELP.TEXT_ALTERNATIVE' | translate">
		<bb-entity-selector [(ngModel)]="playout.textAlternative" [options]="mediaclipOptions" name="text-alternative"></bb-entity-selector>
	</bb-form-element>

	<bb-form-element [hasPublicationField]="'showFrameWhileLoading'" [form]="form"
		[label]="'KEEP_FRAME_VISIBLE_WHILE_LOADING' | translate"
		[helpMessage]="'HELP.KEEP_FRAME_VISIBLE_WHILE_LOADING' | translate">
		<bb-check name="playout-showFrameWhileLoading" [(ngModel)]="playout.showFrameWhileLoading" [trueValue]="'true'"
			[falseValue]="'false'">
		</bb-check>
	</bb-form-element>

	<bb-form-element [hasPublicationField]="'safariMuteWhileLoading'" [form]="form"
		[label]="'MUTE_WHILE_LOADING_SAFARI' | translate"
		[helpMessage]="'HELP.MUTE_WHILE_LOADING_SAFARI' | translate">
		<bb-check name="playout-safariMuteWhileLoading" [(ngModel)]="playout.safariMuteWhileLoading" [trueValue]="'true'"
			[falseValue]="'false'">
		</bb-check>
	</bb-form-element>

	<bb-form-element [hasPublicationField]="'avoidNativeFullscreen'" [form]="form"
		[label]="'AVOID_NATIVE_FULLSCREEN' | translate"
		[helpMessage]="'HELP.PLAYOUT_AVOID_NATIVE_FULLSCREEN' | translate"
		 *ngIf="playout.forceAndroidNativeVideo !== 'true' && playout.forceIOSNativeVideo !== 'true' && playout.forceNativeFullscreen !== 'true'">
		<bb-check name="playout-avoidNativeFullscreen" [(ngModel)]="playout.avoidNativeFullscreen" [trueValue]="'true'"
			[falseValue]="'false'">
		</bb-check>
	</bb-form-element>

	<bb-form-element [form]="form"
		[label]="'MOBILE_ROTATE_ON_FULL_SCREEN_MISMATCH' | translate"
		[helpMessage]="'HELP.MOBILE_ROTATE_ON_FULL_SCREEN_MISMATCH' | translate">
		<bb-check name="playout-mobileRotateOnFullScreenMismatch" [(ngModel)]="playout.mobileRotateOnFullScreenMismatch" [trueValue]="'true'"
			[falseValue]="'false'">
		</bb-check>
	</bb-form-element>

	<bb-form-element [hasPublicationField]="'forceAndroidNativeVideo'" [form]="form"
		[label]="'FORCE_ANDROID_NATIVE_VIDEO' | translate"
		[helpMessage]="'HELP.PLAYOUT_FORCE_ANDROID_NATIVE_VIDEO' | translate"
		*ngIf="playout.avoidNativeFullscreen !== 'true'">
		<bb-check name="playout-forceAndroidNativeVideo" [(ngModel)]="playout.forceAndroidNativeVideo" [trueValue]="'true'"
			[falseValue]="'false'">
		</bb-check>
	</bb-form-element>

	<bb-form-element [hasPublicationField]="'forceIOSNativeVideo'" [form]="form"
		[label]="'FORCE_IOS_NATIVE_VIDEO' | translate"
		[helpMessage]="'HELP.PLAYOUT_FORCE_IOS_NATIVE_VIDEO' | translate"
		*ngIf="playout.avoidNativeFullscreen !== 'true'">
		<bb-check name="playout-forceIOSNativeVideo" [(ngModel)]="playout.forceIOSNativeVideo" [trueValue]="'true'"
			[falseValue]="'false'">
		</bb-check>
	</bb-form-element>

	<bb-form-element [hasPublicationField]="'useCors'" [form]="form" [label]="'USE_CORS' | translate" [helpMessage]="'HELP.USE_CORS' | translate">
		<bb-check name="playout-useCors" [(ngModel)]="playout.useCors" [trueValue]="'true'" [falseValue]="'false'">
		</bb-check>
	</bb-form-element>

	<bb-form-element [hasPublicationField]="'customCode'" [form]="form" [label]="'PLAYER_CUSTOM_CODE' | translate"
		[helpMessage]="'HELP.PLAYER_CUSTOM_CODE' | translate">
		<bb-code-editor name="playout-customCode" [(ngModel)]="playout.customCode"></bb-code-editor>
	</bb-form-element>

</div>
